var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackBlueIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_597_106",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_597_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 18.3333L5.5 9.99996L13.8333 1.66663L15.3125 3.14579L8.45833 9.99996L15.3125 16.8541L13.8333 18.3333Z",
    fill: "#00BCE7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackBlueIc);
export default __webpack_public_path__ + "static/media/arrow-back-blue-ic.6baadc753c284381e52916a0864d80ab.svg";
export { ForwardRef as ReactComponent };